import React from 'react';
import PropTypes from 'prop-types';
import Vimeo from '@u-wave/react-vimeo';
import ImageHandler from './ImageHandler';

// ====================================
// Vimeo video
// ================

const Video = (props) => {
  const {
    source,
    ratio,
    autoPlay,
    isPaused,
    isMuted,
    controls,
    showPortrait,
    showTitle,
    showByline,
    background,
    width,
    height,
    responsive,
    poster,
    loop,
  } = props;
  if (!source) return null;

  return (
    <div
      className="brand-video brand-background-cover brand-background-black"
      style={{
        backgroundImage: `url(${poster})`,
      }}
    >
      <div className="brand-video-embed">
        <iframe
          src={`https://player.vimeo.com/video/${
            source.vimeo_oembed.response.video_id
          }${background ? `?controls=0&loop=1&background=1` : ``}`}
          width="100%"
          height="100%"
          frameBorder="0"
          webkitallowfullscreen
          mozallowfullscreen
          allowfullscreen
          dnt="true"
        />
      </div>
    </div>
  );
};

export default Video;

// ====================================
// PropTypes
// ================

Video.propTypes = {
  source: PropTypes.objectOf({
    embed_url: PropTypes.string.isRequired,
  }).isRequired,
  autoPlay: PropTypes.bool,
  isPaused: PropTypes.bool,
  isMuted: PropTypes.bool,
  controls: PropTypes.bool,
  showPortrait: PropTypes.bool,
  showTitle: PropTypes.bool,
  showByline: PropTypes.bool,
  background: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  responsive: PropTypes.bool,
  loop: PropTypes.bool,
};

Video.defaultProps = {
  autoPlay: false,
  isPaused: false,
  isMuted: true,
  controls: true,
  showPortrait: true,
  showTitle: true,
  showByline: true,
  background: false,
  width: '100%',
  height: '100%',
  responsive: true,
  loop: false,
};

/*
        <Vimeo
          video={source.vimeo_raw}
          autoPlay={autoPlay}
          controls={controls}
          showPortrait={showPortrait}
          showTitle={showTitle}
          showByline={showByline}
          isMuted={isMuted}
          isPaused={isPaused}
          background={background}
          width={width}
          height={height}
          responsive={responsive}
          loop={loop}
          dnt="true"
        />
*/
